import React from "react";
import { Table } from "semantic-ui-react";
import TablaEscuelasRow from "./tablaEscuelas/TablaEscuelasRow";
import sortBy from "lodash/sortBy";

class TablaEscuelas extends React.Component {
  state = {
    column: "nombre",
    data: [],
    direction: "ascending",
    clickToOrder: false
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      column: prevState.column,
      direction: prevState.direction,
      data: prevState.clickToOrder
        ? prevState.data
        : sortBy(nextProps.datos, [prevState.column])
    };
  }

  handleSort = clickedColumn => () => {
    if (this.state.column !== clickedColumn) {
      this.setState(state => ({
        column: clickedColumn,
        data: sortBy(state.data, [clickedColumn]),
        direction: "ascending",
        clickToOrder: true
      }));

      return;
    }
    this.setState(state => ({
      data: state.data.reverse(),
      direction: state.direction === "ascending" ? "descending" : "ascending",
      clickToOrder: true
    }));
  };

  render() {
    const { column, data, direction } = this.state;

    return (
      <Table sortable compact celled selectable>
        <Table.Header>
          <Table.Row style={{ cursor: "pointer" }}>
            <Table.HeaderCell
              sorted={column === "nombre" ? direction : null}
              onClick={this.handleSort("nombre")}
            >
              Colegio
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "poblacion" ? direction : null}
              onClick={this.handleSort("poblacion")}
            >
              Población
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "provincia" ? direction : null}
              onClick={this.handleSort("provincia")}
            >
              Provincia
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map(item => (
            <TablaEscuelasRow
              key={item.id}
              item={item}
              handleClick={this.props.handleRowClick}
            />
          ))}
        </Table.Body>
      </Table>
    );
  }
}

export default TablaEscuelas;



// WEBPACK FOOTER //
// ./src/pages/inscripciones/TablaEscuelas.jsx